import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { LineItemsEntity } from "../entities/line-items-entity";
@Injectable()
export class LineItemsRepository extends Repository<LineItemsEntity> {
    constructor(@InjectRepository(LineItemsEntity) private lineItemsRepository: Repository<LineItemsEntity>
    ) {
        super(lineItemsRepository.target, lineItemsRepository.manager, lineItemsRepository.queryRunner);
    }

}